import { connect } from 'react-redux';
import { getItem } from 'app/models/localStorage/selectors';
import { WEBRTC_DEBUG } from 'app/models/localStorage/constants';
import { USE_RESERVED_FEATURES_ABILITY } from 'app/constants/enums/Ability';
import { AppState } from 'app/store';
import React, { ReactElement } from 'react';
import { IProvideProps, withRestrictions } from 'app/containers/auth/withRestrictions';

interface IProps {
  debugMode: boolean;
  hasPermission: boolean;
  children: (enableDebug: boolean) => ReactElement<any> | null;
}

const HasRtcDebug: React.SFC<IProps> = ({ debugMode, hasPermission, children }) => {
  return children(hasPermission && debugMode);
};

const mapStateToProps = (state: AppState, { isUserRestricted }: IProvideProps) => ({
  debugMode: getItem(state, WEBRTC_DEBUG),
  hasPermission: !isUserRestricted([USE_RESERVED_FEATURES_ABILITY]),
});

export default withRestrictions(connect(mapStateToProps)(HasRtcDebug));
